import fnv1a from '@sindresorhus/fnv1a';

export const normalizeClassificationSource = (content: string): string => content.trim();

export const hashClassificationSource = (content: string): string =>
  fnv1a(normalizeClassificationSource(content), { size: 32 }).toString(16);

// Module names are unique under this normalization: the classifier addresses modules by name, and names that
// differ only in case or surrounding spaces are near-duplicates it could confuse (DM-1544).
export const normalizeModuleName = (name: string): string => name.trim().toLowerCase();
